import { render, staticRenderFns } from "./IfParticipantLanguage.vue?vue&type=template&id=ea937b88&"
import script from "./IfParticipantLanguage.vue?vue&type=script&lang=js&"
export * from "./IfParticipantLanguage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports